import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { AiChatSendMessageDocument } from './send-message.generated';

export const useAiChatSendMessage = (
  options: ApiOptions<typeof AiChatSendMessageDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(AiChatSendMessageDocument, {
    ...useNotifications(AiChatSendMessageDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
    }),
    ...options,
  });
};
